import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Ticket } from '@product/const';
import { ProcessSelectors, StateUtils, StateWithProcess } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CustomProductActions } from '../store/actions';
import { StateWithProduct, TICKET_PROCESS_ID } from '../store/product-state';
import { ProductSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class TicketFacade {
  constructor(private store: Store<StateWithProduct | StateWithProcess<void>>) {}

  requestTransitPrice(ticket: Ticket): void {
    this.store.dispatch(new CustomProductActions.TicketRequest(ticket));
  }

  resetProcess(): void {
    this.store.dispatch(new CustomProductActions.TicketRequestReset());
  }

  getProcess(): Observable<StateUtils.LoaderState<void>> {
    return this.store.pipe(select(ProcessSelectors.getProcessStateFactory(TICKET_PROCESS_ID)));
  }

  getLoading(): Observable<boolean> {
    return this.store.pipe(select(ProductSelectors.getTicketLoading));
  }

  getSuccess(): Observable<boolean> {
    return this.store.pipe(select(ProductSelectors.getTicketSuccess));
  }

  getError(): Observable<boolean> {
    return this.store.pipe(select(ProductSelectors.getTicketError));
  }
}
